import Typo from '@/ui/typo/Typo';
import { Container, Dot, LabelWrapper } from './LegendItemStyles';
import LegendCheckbox from '@/ui/checkbox/legendCheckbox/LegendCheckbox';
import { COLORS } from '@/styles/colorTheme';

const LegendItem = ({ color, children, onClick, isSelected = false }) => {
  return (
    <Container onClick={onClick}>
      <LabelWrapper>
        <Dot color={color} />
        <div className="text-text-400 text-sm">{children}</div>
      </LabelWrapper>
      <LegendCheckbox isSelected={isSelected} onClick={() => {}} />
    </Container>
  );
};

export default LegendItem;
